import React, { useEffect } from 'react';
import { Grid, Box } from '@material-ui/core';
import RouterBreadcrumbs from '../common/BreadCrumbs';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAssetDataByUUID } from '../../redux/actions/manageAssetActions';
import AssetInfo from './AssetInfo';
import SourceAccordion from './Sources/SourceAccordion';
import Typography from '@material-ui/core/Typography';
import AddSourceFilesBtn from './Sources/AddSourceFilesBtn';
import { makeStyles } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Refresh';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
	heading: {
		fontSize: theme.typography.pxToRem(30),
		fontWeight: theme.typography.fontWeightBold,
	},
}));

const ManageAssets = () => {
	const asset = useSelector((state) => state.manageAssetDetails);
	const classes = useStyles();
	const dispatch = useDispatch();
	// getting asset uuid from params
	const { id } = useParams();
	const { name, status } = asset;
	const srcFiles = asset.sourceFiles;
	// sort source files by isPrimary flag. primary source file should appear on the top.
	srcFiles.sort((a, b) => {
		return b.isPrimary - a.isPrimary;
	});
	const srcFilesCount = srcFiles.length;
	useEffect(() => {
		// fetching Asset information by UUID for manage asset component on page load.
		dispatch(fetchAssetDataByUUID(id));
	}, [dispatch, id]);
	return (
		<Grid container>
			<RouterBreadcrumbs />
			<Grid container>
				<AssetInfo id={id} name={name} status={status} asset={asset} />
				<Box m={1}></Box>
			</Grid>
			<Grid container>
				<Grid item xs={12}>
					<Grid container>
						<Grid item xs={7}>
							<Typography className={classes.heading}>Sources - {srcFilesCount} Files</Typography>
						</Grid>
						<Grid item xs={2}>
							<Tooltip title="fetch latest asset details" placement="top" arrow={true}>
								<IconButton
									onClick={() => dispatch(fetchAssetDataByUUID(id))}
									color="primary"
									data-cy="asset-page-refresh"
									size="small"
								>
									<RefreshIcon /> Refresh
								</IconButton>
							</Tooltip>
						</Grid>
						<Grid item xs={3}>
							<AddSourceFilesBtn asset={asset} />
						</Grid>
					</Grid>
				</Grid>
				<Box m={1}></Box>
				<Grid container>
					{srcFiles.map((srcFile) => {
						return (
							<Box key={srcFile.id}>
								<SourceAccordion asset={asset} sourceFile={srcFile} />
							</Box>
						);
					})}
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ManageAssets;
